import React, { useState } from 'react';
import { Carousel } from 'antd';
import { motion } from 'framer-motion';

// Define animation variants for the text
const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1, ease: 'easeOut' } },
};

// Define animation variants for the image
const imageVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1.5, ease: 'easeIn' } },
};

// Define animation variants for the button
const buttonVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 1, ease: 'easeOut', delay: 0.5 },
  },
};

const contentStyle = {
  width: '100%',
  objectFit: 'cover',
  //   height: '500px',
  //   height: 'auto',
  color: '#fff',
  lineHeight: '300px',
  textAlign: 'center',
  background: '#364d79',
  draggable: true,
};

const App = () => {
  const [activeSlide, setActiveSlide] = useState(0); // Track the current slide
  const slides = [
    {
      url: 'https://cdn.finzaid.com/advertisement/adz-0.png',
      title: 'Master Finance with Confidence',
      description:
        'Unlock the world of finance with confidence. Our expert-led courses cover essential strategies, tools, and insights to strengthen your financial knowledge and help you make informed decisions.',
      link: 'https://www.example.com/finance-course',
    },
    {
      url: 'https://cdn.finzaid.com/advertisement/adz-1.png',
      title: 'Empower Your Trading Skills',
      description:
        'Take your trading skills to the next level. Dive into advanced techniques and gain actionable insights from seasoned traders for both short-term and long-term investments.',
      link: 'https://www.example.com/trading-skills',
    },
    {
      url: 'https://cdn.finzaid.com/advertisement/adz-2.png',
      title: 'Build Wealth with Strategic Finance',
      description:
        'Develop a strategic approach to finance. Our in-depth courses are designed to give you the skills needed to grow your wealth and make smart financial choices in any economic climate.',
      link: 'https://www.example.com/wealth-strategy',
    },
    {
      url: 'https://cdn.finzaid.com/advertisement/adz-3.png',
      title: 'Trading Success Starts Here',
      description:
        'Gain the knowledge you need to trade successfully. Learn proven techniques, market analysis, and risk management strategies from experts to boost your confidence in trading.',
      link: 'https://www.example.com/trading-success',
    },
  ];

  return (
    <div className="lg:p-5 h-auto relative mt-5 sm:mt-[20px] md:mt-[40px] lg:mt-[60px]">
      <Carousel
        autoplay
        autoplaySpeed={3000}
        draggable
        infinite
        beforeChange={(current, next) => setActiveSlide(next)} // Update active slide
      >
        {slides?.map((slide, index) => (
          <div key={index} className="relative">
            <motion.img
              className="rounded-lg w-full h-auto md:h-[500px] object-fit"
              style={contentStyle}
              src={slide?.url}
              alt={`slide-${index}`}
              initial="hidden"
              animate={activeSlide === index ? 'visible' : 'hidden'} // Animate only the active slide
              variants={imageVariants}
            />
            <motion.div
              className="absolute bottom-12 md:bottom-20 left-1/2 transform -translate-x-1/2 text-center"
              initial="hidden"
              animate={activeSlide === index ? 'visible' : 'hidden'} // Animate only the active slide
              variants={textVariants}
            >
              <h1 className="text-gray-100 text-sm md:text-4xl font-bold mb-3">
                {slide?.title}
              </h1>
              <p className="text-gray-100 text-xs md:text-lg mt-4 px-4 hidden sm:block md:mb-10">
                {slide?.description}
              </p>
              <motion.a
                href={slide?.link}
                className="py-1 px-3 md:py-2 md:px-6 mt-4  rounded-lg text-xs sm:text-md lg:text-xl transition duration-300 "
                style={{
                  backgroundColor: 'var(--btn-selected-color)', // Use the CSS variable
                  color: 'black',
                }}
                target="_blank"
                rel="noopener noreferrer"
                initial="hidden"
                animate={activeSlide === index ? 'visible' : 'hidden'}
                variants={buttonVariants}
              >
                Learn More
              </motion.a>
            </motion.div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default App;
